import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
  Box,
  CircularProgress
} from "@mui/material";
import { Component } from "react";
import { ReactComponent as DropIcon } from "../../resources/images/icons-chevron-double.svg";
import { ReactComponent as RemoveIcon } from "../../resources/images/icons-remove.svg";
import { TextField } from "../TextField";

export class CourseSelector extends Component<any, any> {
  static defaultProps = {
    label: "Training",
    allowMultiple: false,
    labelKey: "name"
  };

  constructor(props: any) {
    super(props);
  }

  onChange(e: any, course: any, reason: AutocompleteChangeReason) {
    const { onChange } = this.props;

    if (reason === "removeOption" && e?.type !== "click") return;
    onChange?.(e, course);
  }

  onInputChange(e: any, value: string, reason: AutocompleteInputChangeReason) {
    const { onSearch } = this.props;

    if (reason === "input") {
      onSearch?.(value);
    }
  }

  onBlur(e: any) {
    const { onBlur } = this.props;

    if (onBlur) onBlur(e);
  }

  renderOption(props: any, option: any) {
    const { labelKey } = this.props;

    return (
      <li {...props} key={option.id}>
        {option[labelKey]}
      </li>
    );
  }

  render() {
    const {
      label,
      allowMultiple,
      sx,
      placeholder,
      options,
      value,
      error,
      errorMessage,
      disabled,
      isLoading,
      labelKey
    } = this.props;

    return (
      <Autocomplete
        id='klayo-attributeselector'
        className='klayo-attributeselector klayo-selector'
        options={options}
        value={value}
        getOptionLabel={(option) => {
          return option[labelKey];
        }}
        renderOption={this.renderOption.bind(this)}
        disabled={disabled}
        multiple={allowMultiple}
        popupIcon={<DropIcon />}
        clearIcon={<RemoveIcon />}
        ChipProps={{
          deleteIcon: <RemoveIcon />
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label={label}
              placeholder={placeholder}
              disabled={disabled}
              error={error}
              helperText={errorMessage}
              sx={{ width: "100%" }}
              endAdornment={params.InputProps.endAdornment}
            />
          );
        }}
        onChange={this.onChange.bind(this)}
        onInputChange={this.onInputChange.bind(this)}
        onBlur={this.onBlur.bind(this)}
        sx={sx}
        loading={isLoading}
        loadingText={
          <Box display='flex' justifyContent={"center"} alignItems={"center"}>
            <CircularProgress size={20} />
          </Box>
        }
        isOptionEqualToValue={(option, value) => option.id === value.id}
      />
    );
  }
}
